import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  ALERT,
  ALERTS,
  ALERTS_PRIORITY_COUNT,
  ALERT_DASHBOARD,
  ALERT_DASHBOARD_BY_CASE_MANAGER,
  ALERT_DASHBOARD_BY_FACILITY,
  ALERT_HISTORY,
  ALERT_TYPES,
  COURSES,
  CREATE_PATIENT_ACTIVITY,
  NEW_ALERTS_COUNT,
  PATIENT,
  PATIENTS,
  PATIENT_CHAT_TOTAL_MESSAGES,
  PATIENT_COMPLIANCE,
  PATIENT_COURSES,
  PATIENT_COURSES_SET_ACTIVE,
  PATIENT_ENROLLED_PROGRAM,
  PATIENT_READING_ANSWERS,
  PATIENT_REWARD_HISTORY,
  PATIENT_WALLET,
  PATIENT_WALLET_HISTORY,
  RESET_PATIENT_COURSE,
  SENS_SMS_APP_LINK
} from 'src/constants'

export default {
  async getPatients(config = {}) {
    const { params, query } = config
    try {
      const response = await httpClient.get({
        pathname: PATIENTS,
        params,
        query
      })
      return response
    } catch (err) {
      catchError(err)
      throw err
    }
  },

  postPatient(payload) {
    return httpClient.post(PATIENTS, payload)
  },

  getPatientProfile(params, query) {
    return httpClient.get({
      pathname: PATIENT,
      params,
      query
    })
  },

  patchPatientProfile(params, query, payload) {
    return httpClient.patch(
      {
        pathname: PATIENT,
        params,
        query
      },
      payload
    )
  },

  getActiveEnrolledProgram(params) {
    return httpClient.get({
      pathname: PATIENT_ENROLLED_PROGRAM,
      params
    })
  },

  getPatientCourses(params, query) {
    return httpClient.get({
      pathname: PATIENT_COURSES,
      params,
      query
    })
  },

  resetPatientCource(params) {
    return httpClient.post({
      pathname: RESET_PATIENT_COURSE,
      params
    })
  },

  getCourses(config = {}) {
    const { params, query } = config
    return httpClient.get({
      pathname: COURSES,
      params,
      query
    })
  },

  postCourses(params, payload) {
    return httpClient.post(
      {
        pathname: PATIENT_COURSES,
        params
      },
      payload
    )
  },

  deleteCourses(params, payload) {
    return httpClient.delete(
      {
        pathname: PATIENT_COURSES,
        params
      },
      payload
    )
  },

  activateCourses(params, payload) {
    return httpClient.post(
      {
        pathname: PATIENT_COURSES_SET_ACTIVE,
        params
      },
      payload
    )
  },

  createPatientActivityLog({ params = {}, payload = {} }) {
    return httpClient.post(
      {
        pathname: CREATE_PATIENT_ACTIVITY,
        params
      },
      payload
    )
  },

  getAlertTypes(
    params = '',
    query = {
      'per-page': 99999
    }
  ) {
    return httpClient.get({
      pathname: ALERT_TYPES,
      params,
      query
    })
  },

  getAlerts(params, query) {
    return httpClient.get({
      pathname: ALERTS,
      params,
      query
    })
  },

  getAlert(params, query) {
    return httpClient.get({
      pathname: ALERT,
      params,
      query
    })
  },

  getAlertHistory(params = '', query = '') {
    return httpClient.get({
      pathname: ALERT_HISTORY,
      params,
      query
    })
  },

  postAlertHistory(params, query, payload) {
    return httpClient.post(
      {
        pathname: ALERT_HISTORY,
        params,
        query
      },
      payload
    )
  },

  getNewAlertsCount(params = '', query = '') {
    return httpClient.get({
      pathname: NEW_ALERTS_COUNT,
      params,
      query
    })
  },

  getAlertsPriorityCount(params, query) {
    return httpClient.get({
      pathname: ALERTS_PRIORITY_COUNT,
      params,
      query
    })
  },

  getPatientWallet(config = {}) {
    const { params, query } = config

    return httpClient.get({
      pathname: PATIENT_WALLET,
      params,
      query
    })
  },

  getPatientWalletHistory(config = {}) {
    const { params, query } = config

    return httpClient.get({
      pathname: PATIENT_WALLET_HISTORY,
      params,
      query
    })
  },

  adjustPatientCurrency(config = {}) {
    const { params, payload } = config

    return httpClient.patch(
      {
        pathname: PATIENT_WALLET,
        params
      },
      payload
    )
  },

  getPatientRewardHistory(config = {}) {
    const { params, query } = config

    return httpClient.get({
      pathname: PATIENT_REWARD_HISTORY,
      params,
      query
    })
  },

  getPatientCompliance(config = {}) {
    const { params, query } = config

    return httpClient.get({
      pathname: PATIENT_COMPLIANCE,
      params,
      query
    })
  },

  getPatientChatTotalMessages(config = {}) {
    const { params, query } = config

    return httpClient.get({
      pathname: PATIENT_CHAT_TOTAL_MESSAGES,
      params,
      query
    })
  },

  sendSmsAppLink(config = {}) {
    const { params, payload } = config

    return httpClient.post(
      {
        pathname: SENS_SMS_APP_LINK,
        params
      },
      payload
    )
  },

  getPatientReadingAnswers(config = {}) {
    const { params, query } = config

    return httpClient.get({
      pathname: PATIENT_READING_ANSWERS,
      params,
      query
    })
  },

  async getDashboardAlerts(query) {
    try {
      const response = await httpClient.get({
        pathname: ALERT_DASHBOARD,
        query
      })
      return response
    } catch (err) {
      catchError(err)
      throw err
    }
  },

  async getDashboardAlertsByCM(query) {
    try {
      const response = await httpClient.get({
        pathname: ALERT_DASHBOARD_BY_CASE_MANAGER,
        query
      })
      return response
    } catch (err) {
      catchError(err)
      throw err
    }
  },

  async getDashboardAlertsByFacility(query) {
    try {
      const response = await httpClient.get({
        pathname: ALERT_DASHBOARD_BY_FACILITY,
        query
      })
      return response
    } catch (err) {
      catchError(err)
      throw err
    }
  }
}
